var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "-10 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7063 29.3372C9.99136 27.0997 8.53124 25.2277 7.28882 23.6348C5.06259 20.7806 3.53533 18.8225 2.49353 17.2635C1.68872 16.0591 1.19606 15.1241 0.900776 14.2267C0.607166 13.3344 0.500122 12.4531 0.500122 11.3446C0.500122 5.40355 5.86886 0.500061 12.6052 0.500061C19.3415 0.500061 24.7102 5.40355 24.7102 11.3446C24.7102 12.4531 24.6032 13.3344 24.3096 14.2267C24.0143 15.1241 23.5216 16.0591 22.7168 17.2635C21.675 18.8225 20.1477 20.7806 17.9215 23.6349C16.679 25.2278 15.2188 27.1 13.5037 29.3376C13.0778 29.8905 12.132 29.8903 11.7063 29.3372Z",
    fill: "#1E73BE",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5392 13.5391L16.4957 10.4782C16.3566 10.0609 16.0087 9.78259 15.5913 9.78259H12.7392V13.6782H17.6087C17.6087 13.6782 17.6087 13.6087 17.5392 13.5391ZM12.0435 9.78259H9.19134C8.77395 9.78259 8.35656 10.0609 8.28699 10.4782L7.24352 13.5391C7.24352 13.6087 7.24352 13.6087 7.24352 13.6782H12.1131V9.78259H12.0435ZM17.6087 14.3739V19.2435C17.6087 19.8 17.1913 20.2174 16.6348 20.2174H8.14786C7.59134 20.2174 7.17395 19.8 7.17395 19.2435V14.3739H17.6087ZM12.1131 15.5565C12.1131 15.3478 11.9044 15.2782 11.7653 15.4174L10.0957 16.8087C9.95656 16.8782 9.95656 17.0869 10.0957 17.1565L11.7653 18.5478C11.9044 18.6869 12.1131 18.5478 12.1131 18.4087V17.5739C13.574 17.5739 14.2 17.9217 13.7826 19.313C13.7131 19.4522 13.9218 19.5913 14.0609 19.4522C14.4783 19.1739 14.8261 18.6174 14.8261 17.9913C14.8261 16.6 13.6435 16.2522 12.1131 16.2522V15.5565Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4348,
    height: 10.4348,
    fill: "white",
    transform: "translate(7.17395 9.78259)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.daef9a8e771999c83cf011bab579a170.svg";
export { ForwardRef as ReactComponent };